import { useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { selfHireService } from '../services/selfHireService'

interface UseGetByIdLinkProps {
  linkId: string
  enabled?: boolean
}

export const useGetByIdLink = ({ linkId }: UseGetByIdLinkProps) => {
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['linkbyId', linkId],
    queryFn: async () => selfHireService.getByIdLink(linkId),
    enabled: !!linkId,
  })

  const { toast } = useToast()

  if (isError) {
    toast({
      variant: 'destructive',
      title: 'Erro ao carregar os dados do link, tente novamente mais tarde!',
    })
  }

  return {
    isLoading,
    isFetching,
    data,
  }
}
